import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, LayoutGrid } from "lucide-react";
import P2PHowItWorks from "../P2PHowItWorks";
import PitDuelSlip from "./PitDuelSlip";

const P2PDetail = ({
  bet,
  siblingStances = [],
  onSelectStance,
  onBackToList,
  onBackToFloor,
  userId,
  onNotify,
  onRefresh,
  onUpdated,
  isAuthenticated,
}) => {
  if (!bet) {
    return (
      <section className="pit-detail pit-detail-idle">
        <div className="pit-idle">
          <p className="pit-idle-eyebrow">BondP2P · Open bets</p>
          <p className="pit-idle-title">Pick a P2P bet to bet against</p>
          <p className="pit-idle-copy">
            One person backs an outcome with a budget and odds. You counter with
            your own stake (at or above the min). Choose a bet from the left.
          </p>
          <Link
            to={isAuthenticated ? "/app/p2p/create" : "/app/login"}
            state={isAuthenticated ? undefined : { from: "/app/p2p/create" }}
            className="pit-idle-cta"
          >
            Create P2P
          </Link>
        </div>
        <div className="pit-idle-aside">
          <P2PHowItWorks />
        </div>
      </section>
    );
  }

  return (
    <section className="pit-detail" aria-label="Duel detail">
      {onBackToList && (
        <button
          type="button"
          className="pit-mobile-back"
          onClick={onBackToList}
        >
          <ChevronLeft size={14} aria-hidden />
          All P2P bets
        </button>
      )}
      {onBackToFloor && (
        <button
          type="button"
          className="pit-floor-back"
          onClick={onBackToFloor}
        >
          <LayoutGrid size={11} aria-hidden />
          Floor overview
        </button>
      )}
      <div className="pit-detail-body">
        <PitDuelSlip
          bet={bet}
          siblingStances={siblingStances}
          onSelectStance={onSelectStance}
          userId={userId}
          onNotify={onNotify}
          onRefresh={onRefresh}
          onUpdated={onUpdated}
        />
      </div>
    </section>
  );
};

export default P2PDetail;
